import React, { useState } from 'react';

export const ROICalculator = () => {
  const [classPrice, setClassPrice] = useState(25);
  const [classesPerWeek, setClassesPerWeek] = useState(4);
  const [athletesPerClass, setAthletesPerClass] = useState(12);
  const [affiliationFee, setAffiliationFee] = useState(125);
  const monthlyRevenue = classPrice * classesPerWeek * athletesPerClass * 4.33;
  const monthlyProfit = monthlyRevenue - affiliationFee;
  const roiMultiple = affiliationFee > 0 ? Math.round(monthlyRevenue / affiliationFee) : 0;

  const fields = [
    { l: 'Class Price ($)', v: classPrice, s: setClassPrice },
    { l: 'Classes / Week', v: classesPerWeek, s: setClassesPerWeek },
    { l: 'Athletes / Class', v: athletesPerClass, s: setAthletesPerClass },
  ];

  return (
    <div className="bg-zinc-900/80 border border-[#e8ff00]/20 p-6 md:p-8" data-testid="roi-calculator">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {fields.map((f) => (
          <div key={f.l}>
            <label className="text-zinc-500 text-[10px] uppercase tracking-wider block mb-2 font-heading">{f.l}</label>
            <input
              type="number"
              value={f.v}
              onChange={(e) => f.s(Number(e.target.value))}
              className="w-full px-3 py-2.5 bg-zinc-800 border border-zinc-700 text-white text-sm focus:border-[#e8ff00] focus:outline-none transition-colors"
            />
          </div>
        ))}
        <div>
          <label className="text-zinc-500 text-[10px] uppercase tracking-wider block mb-2 font-heading">Plan</label>
          <select
            value={affiliationFee}
            onChange={(e) => setAffiliationFee(Number(e.target.value))}
            className="w-full px-3 py-2.5 bg-zinc-800 border border-zinc-700 text-white text-sm focus:border-[#e8ff00] focus:outline-none"
          >
            <option value={130}>Monthly ($130/mo)</option>
            <option value={125}>Annual (~$125/mo)</option>
          </select>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-3">
        <div className="bg-zinc-800 p-4 text-center border border-zinc-700">
          <p className="text-2xl font-heading text-green-500">${Math.round(monthlyRevenue).toLocaleString()}</p>
          <p className="text-zinc-500 text-[10px] uppercase tracking-wider mt-1">Monthly Revenue</p>
        </div>
        <div className="bg-zinc-800 p-4 text-center border border-zinc-700">
          <p className={`text-2xl font-heading ${monthlyProfit >= 0 ? 'text-green-500' : 'text-red-500'}`}>
            ${Math.round(monthlyProfit).toLocaleString()}
          </p>
          <p className="text-zinc-500 text-[10px] uppercase tracking-wider mt-1">Monthly Profit</p>
        </div>
        <div className="bg-zinc-800 p-4 text-center border border-zinc-700">
          <p className="text-2xl font-heading text-[#e8ff00]">{roiMultiple}x</p>
          <p className="text-zinc-500 text-[10px] uppercase tracking-wider mt-1">ROI Multiple</p>
        </div>
      </div>
    </div>
  );
};
